import { createIcon } from "@chakra-ui/icons";

// Created from arrow-right.svg

export const RightArrowIcon = createIcon({
  displayName: "Right Arrow",
  viewBox: "0 0 16 16",
  path: (
    <g>
      <path
        d="M1 8H14.3333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.33398L14.6667 8.00065L10 12.6673"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </g>
  ),
});
